<template>
  <adds :id='$route.query.id' :type='$route.query.type' :storename='$route.query.name'></adds>
</template>
<script>
import adds from './components/adds'
export default {
  components: { adds },
  setup(props) {
  } 
  
}
</script>